
import Vue from 'vue';
import {
  mapGetters, mapActions,
} from 'vuex';
import moment from 'moment';
import Button from '@/components/Button/index.vue';
import Select from '@/components/SelectProp/index.vue';
import VueQRCodeComponent from 'vue-qrcode-component';
import { createPayment, CreatePaymentParams } from '@/services/payments/create-payments';
import { getTicket } from '@/services/ticket/get-ticket';
import { generateLinkGix, GenerateLinkGixParams } from '@/services/gix/generate-link-gix';
import getCalculateTicket from '@/services/tickets/get-tickets-total';
import { genaratePix } from '@/services/pix/post-pix';
import { getPixTxId } from '@/services/pix/get-pix-txid';

moment.locale('pt-br');
Vue.component('qr-code', VueQRCodeComponent);

export default Vue.extend({
  components: {
    Select,
    Button,
  },
  inject: [
    'userLogged',
    'resetStepsRegisterTerritory',
    'getStepDate',
  ],
  data() {
    return {
      isErrorHiddenMessage: true,
      isLoading: false,
      isSelected: false,
      userLogged: JSON.parse(sessionStorage.getItem('userLogged') as string),
      dataTickets: {} as any,
      amountAll: 0,
      total: 0,
      txId: 'BOLETO34875790421119128DAT',
      force: 0,
      objectPix: {
        calendario: {
          expiracao: 3600,
        },
        devedor: {
          cpf: this.userLogged.stDocument,
          nome: this.userLogged.stName,
        },
        valor: {
          original: '',
        },
        chave: process.env.VUE_APP_KEY_PIX,
        solicitacaoPagador: 'Serviço realizado.',
        infoAdicionais: [],
        // @ts-ignore
      } as any,
      qrCode: '',
    };
  },
  computed: {
    ...mapGetters([
      'DataPix',
    ]),
    formatInstallments(): string[] {
      return Array.from({ length: this.getStepDate.penalty.totalInstallments }, (_, index) => {
        const current = index + 1;
        const penaltyValueInstallments = this.formatNumber(
          this.getStepDate.penalty.penaltyValue / current,
        );
        return `${current}x sem juros de ${penaltyValueInstallments}`;
      });
    },
  },
  methods: {
    ...mapActions({
      generatePix: 'generatePix',
      getPix: 'getPix',
    }),
    formatNumber(value: number) {
      return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    },
    async pixGenerate() {
      // @ts-ignore
      this.objectPix.valor.original = this.amountAll.toString();
      await genaratePix(this.objectPix, this.txId, this.$route.params.id);
      const response = await getPixTxId(this.$route.params.id, this.userLogged.company.stKey);
      this.qrCode = response[0].qrCode;
    },
    inputItem() {
      this.isSelected = true;
    },
    onHiddenMessage() {
      if (!this.getStepDate.penalty.installments) {
        this.isErrorHiddenMessage = false;
        return;
      }
      this.isErrorHiddenMessage = true;
    },
    async onNextStepSix() {
      try {
        this.isLoading = true;
        await this.createPaymentRequest();
        this.getTicketRequest();
        this.getGenerateGixLinkRequest();
        this.getStepDate.currentStep += 1;
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
        this.resetStepsRegisterTerritory();
        this.getStepDate.isErrors = true;
      }
    },
    onSelectInput(_: string, index: number) {
      this.getStepDate.penalty.installments = index;
    },
    async createPaymentRequest() {
      const { stPhone } = this.userLogged;
      const { stDocument } = this.userLogged;
      const params: CreatePaymentParams = {
        name: 'LIVRARIA CUNHA DA CUNHA', // TODO add "stName"
        numInscricao: stDocument, // TODO add "stDocument"
        address: this.getStepDate.address.address,
        number: this.getStepDate.address.number,
        cep: this.getStepDate.address.zipCode.replaceAll('-', ''),
        city: this.getStepDate.address.city,
        neighboor: this.getStepDate.address.neighborhood,
        uf: this.getStepDate.address.state,
        telephone: stPhone,
        initialInstallmentToProcess: 1,
        quantityOfInstallmentsToProcess: +this.getStepDate.penalty.installments,
        totalInstallment: +this.getStepDate.penalty.installments,
        totalPenaltyDue: this.getStepDate.penalty.penaltyValue,
        cdTerritory: this.getStepDate.territory.id,
      };

      const response = await createPayment(params);

      if (response?.hasErrors) {
        this.getStepDate.isErrors = true;
      }
    },
    getTicketRequest() {
      const loader = this.$loading.show({
        container: this.$refs.loadingContainer,
      });
      // @ts-ignore
      getTicket({ cdTerritory: this.getStepDate.territory.id })
        .then((data) => {
          loader.hide();
          this.getStepDate.tickets = data;
          this.getStepDate.isLoadingPayment = false;
        })
        .catch(() => {
          this.resetStepsRegisterTerritory();
          this.getStepDate.isErrors = true;
        });
    },
    getGenerateGixLinkRequest() {
      const params: GenerateLinkGixParams = {
        TokenKey: this.userLogged.company.stKey,
        NameTerritory: this.getStepDate.territory.name,
        CdUser: this.userLogged.idUser,
        CdTerritory: this.getStepDate.territory.id,
        CdJourneyModel: 1,
        CdJourneyGroupModel: 1,
        CdJourneyGroupTaskModel: [1, 2, 3, 4],
      };

      generateLinkGix(params).then((data) => {
        this.getStepDate.gixUrl = data;
      });
    },
  },
  created() {
    getCalculateTicket({ cdTerritory: this.$route.params.id });
    getCalculateTicket({ cdTerritory: this.$route.params.id })
      .then((data) => {
        this.dataTickets = data.objectResult;
        if (this.dataTickets[0].paymentPayed === '0') {
          this.amountAll = this.dataTickets[0].totalAmount;
          this.txId += Math.random().toString(36).slice(4);
        } else {
          this.total = parseFloat(this.dataTickets.length) - parseFloat(this.dataTickets[0].paymentPayed);
          this.amountAll = this.dataTickets[0].amount * this.total;
          this.txId += Math.random().toString(36).slice(4);
          this.getStepDate.isLoadingPayment = false;
        }
      })
      .catch(() => {
        this.resetStepsRegisterTerritory();
        this.getStepDate.isErrors = true;
      });
  },
});
